export default __webpack_public_path__ + "static/odd-left-decoration-d66e4a97202d1e73807168ad956b4ba6.png";